import React, { useState } from 'react'
import { csvGetReq, importCSV } from "../middleware/AxiosApisCallExport";
import { SuccessAlert, ErrorAlert } from "../middleware/AlertMsg"; //1
import Progress from "../Partials/Progress";
import fileDownload from 'js-file-download';

function BulkUpload(props) {

  const [ComponentName, setComponentName] = useState(props.ComponentName);
  const [file, setFile] = useState("");
  // const [filename, setFilename] = useState("Choose File");
  // const [uploadPercentage, setUploadPercentage] = useState(0);
  // const [uploadedFile, setUploadedFile] = useState({});
  const [tableRefresh, setTableRefresh] = useState(0)
  
  const onChange = (e) => {

    setFile(e.target.files[0]);
    // setFilename(e.target.files[0].name);
  };


  const sampleCSVFile = async () => {
    const response = await csvGetReq(`${props.path}/SampleCSV`);
    if (response) {
      fileDownload(response, "csvreport.csv");
      SuccessAlert({
        title: "Sample Upload File",
        message: "Sample Upload file Downloaded successfully",
      });
    } else {
      ErrorAlert({ title: "Update Slot", message: response.msg });
    }
  };



  const bulkUpload = async (event) => { //TODO:Submit Search Form
    event.preventDefault();
    const formData = new FormData();
    formData.append("file", file);
    const response = await importCSV(`${props.path}`, formData);
    if (response.success) {
      if (response.data.dataupload === "success") {
        SuccessAlert({
          title: `Import ${props.ComponentName} File`,
          message: `Import  ${props.ComponentName} file Uploaded successfully`,
        });


        setTableRefresh(tableRefresh + 1)

        // props.importSuccess();
      }
      else {
        props.rejectdata(response.data.reject_data);
        ErrorAlert({ title: "Import File", message: `${response.data.reject_data.length} Data Rejected ` });
      }
    } else {
      ErrorAlert({ title: "Import File", message: response.msg });
    }

  };


  return (
    <React.Fragment>
      <div className="add-user-container">
        <div className="componet-sub-title flex-col flex-space-bt">
          <span>

            {`Bulk ${ComponentName} Upload`}
          </span>
          <div className="option-btn">
            <button onClick={sampleCSVFile}>
              {`Download Sample file`}
            </button>
          </div>
        </div>

        {/* {(uploadPercentage != 0) && <Progress percentage={uploadPercentage} />} */}

        <form className="flex-col" onSubmit={bulkUpload}>
          <div className="input-lable-v-div">
            <label htmlFor="file">Select File</label>
            <input className="file-upload-input"
              type="file"
              onChange={onChange}
              id="file"
            />
          </div>

          <div className="input-lable-h-div">
            <button className="submit-btn" type="submit">
              {`Upload`}
            </button>
          </div>

          {/* {uploadedFile ? (
            <div>
              <div>
                <h3>{uploadedFile.fileName}</h3>
                <img style={{ width: "100%" }} src={uploadedFile.filePath} alt="" />
              </div>
            </div>
          ) : null} */}
        </form>
      </div>

    </React.Fragment>

  )
};

export default BulkUpload